var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('popover',{attrs:{"name":"tooltip","pointer":_vm.pointer,"width":_vm.width,"event":_vm.event},on:{"show":function($event){_vm.value = $event.value}}},[_vm._v("\n  "+_vm._s(_vm.value)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }